"use client";

import { useEffect, useState } from "react";
import { Box, Button, Card, Flex, Grid, Separator } from "@radix-ui/themes";
import DraftPagesWidget from "./DraftPagesWidget";
import { ContentItemApprovalWidget } from "./ContentItemApprovalWidget";

type ITab = "#content-approval-tab" | "#draft-pages-tab";

const components = {
  "#content-approval-tab": ContentItemApprovalWidget,
  "#draft-pages-tab": DraftPagesWidget,
};

export default function UserDashboardPage() {
  const [activeTab, setActiveTab] = useState<ITab>("#content-approval-tab");

  useEffect(() => {
    if (window.location.hash !== "" && components[window.location.hash]) {
      setActiveTab(window.location.hash as ITab);
    }
  }, []);

  const navItems: { id: ITab; label: string; show: boolean }[] = [
    {
      id: "#content-approval-tab",
      label: "Content Approval Requests",
      show: true,
    },
    { id: "#draft-pages-tab", label: "Draft Pages", show: true },
  ];

  const ContentComponent = components[activeTab];

  return (
    <Box id="sb-main-content" role="main">
      <Card size="3">
        <Grid columns={{ initial: "1fr", sm: "200px auto 1fr" }} gap="4">
          <Flex
            direction="column"
            gap="1"
            role="tablist"
            aria-orientation="vertical"
          >
            {navItems
              .filter((item) => item.show)
              .map((item) => (
                <Button
                  key={item.id}
                  asChild
                  variant="ghost"
                  size={"3"}
                  color={activeTab === item.id ? undefined : "gray"}
                  style={{
                    justifyContent: "flex-start",
                    textAlign: "left",
                    boxSizing: "border-box",
                    width: "100%",
                    margin: 0,
                    backgroundColor:
                      activeTab === item.id ? "var(--accent-a3)" : undefined,
                  }}
                >
                  <a
                    href={item.id}
                    onClick={(e) => {
                      e.preventDefault();
                      setActiveTab(item.id);
                      history.replaceState(null, "", item.id);
                    }}
                    role="tab"
                    aria-selected={activeTab === item.id}
                  >
                    {item.label}
                  </a>
                </Button>
              ))}
          </Flex>
          <Separator
            orientation={{ initial: "horizontal", sm: "vertical" }}
            size="4"
            style={{ backgroundColor: "var(--gray-6)" }}
          />
          <Box width={"100%"}>
            <ContentComponent />
          </Box>
        </Grid>
      </Card>
    </Box>
  );
}
